export let AuthBoundaryType = /*#__PURE__*/function (AuthBoundaryType) {
  AuthBoundaryType["Block"] = "Block";
  AuthBoundaryType["Mask"] = "Mask";
  return AuthBoundaryType;
}({});